import { useState, useEffect, useCallback } from 'react'

export const CONSENT_KEY = 'swim_consent_v1'

export interface ConsentPreferences {
  analytics: boolean
  errorTracking: boolean
}

export function getStoredConsent(): ConsentPreferences | null {
  try {
    const stored = localStorage.getItem(CONSENT_KEY)
    return stored ? (JSON.parse(stored) as ConsentPreferences) : null
  } catch {
    return null
  }
}

export function useConsent() {
  const [preferences, setPreferences] = useState<ConsentPreferences | null>(null)
  const [showBanner, setShowBanner] = useState(false)

  useEffect(() => {
    const stored = getStoredConsent()
    if (stored) {
      setPreferences(stored)
    } else {
      setShowBanner(true)
    }
  }, [])

  const save = useCallback((prefs: ConsentPreferences) => {
    try {
      localStorage.setItem(CONSENT_KEY, JSON.stringify(prefs))
    } catch {
      // localStorage unavailable — consent persists in memory only
    }
    setPreferences(prefs)
    setShowBanner(false)
  }, [])

  const acceptAll = useCallback(() => save({ analytics: true, errorTracking: true }), [save])
  const rejectAll = useCallback(() => save({ analytics: false, errorTracking: false }), [save])

  return { preferences, showBanner, save, acceptAll, rejectAll }
}
